export default "__VITE_ASSET__BaGwI_VT__"